module.exports = __webpack_public_path__ + "img/nation.4a311aa3.png";